import { render, staticRenderFns } from "./WaterParameter.vue?vue&type=template&id=04ca82bb&scoped=true&"
import script from "./WaterParameter.vue?vue&type=script&lang=js&"
export * from "./WaterParameter.vue?vue&type=script&lang=js&"
import style0 from "./WaterParameter.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./WaterParameter.vue?vue&type=style&index=1&id=04ca82bb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ca82bb",
  null
  
)

export default component.exports